import { useCallback, useEffect, useState } from 'react';

import {
  getAutoMakes,
  isSuperDispatchVehicleCatalogLoaded,
  loadSuperDispatchVehicleCatalog,
} from '../FTL/superDispatchVehicleCatalog';

export function useSuperDispatchVehicleCatalog(enabled = true) {
  const [isReady, setIsReady] = useState(isSuperDispatchVehicleCatalogLoaded());
  const [loadError, setLoadError] = useState(false);
  const [loadAttempt, setLoadAttempt] = useState(0);

  const retryLoad = useCallback(() => {
    setLoadAttempt((attempt) => attempt + 1);
  }, []);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    if (isSuperDispatchVehicleCatalogLoaded()) {
      setIsReady(true);
      setLoadError(false);
      return;
    }

    let cancelled = false;
    setLoadError(false);

    void loadSuperDispatchVehicleCatalog()
      .then(() => {
        if (!cancelled) {
          setIsReady(true);
          setLoadError(false);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setIsReady(false);
          setLoadError(true);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [enabled, loadAttempt]);

  return {
    isReady: enabled && isReady,
    loadError: enabled && loadError,
    makes: isReady ? getAutoMakes() : [],
    retryLoad,
  };
}
